import { useState } from "react";

const equipment = [
  {
    id: 1,
    name: "Operating Tables",
    category: "Sterilization",
    description: "Advanced multi-position surgical tables with LED Shadowless operating Lights . hydraulic or Electrical Operating tables &nbsp;with motorized adjustment, carbon fiber tops, and full radiolucent capabilities for all surgical specialties.&nbsp;",
    specs: ["Motorized & Manual Positions", "Carbon Fiber Top", "Radiolucent", "Max Load: 350 kg"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/52ddb6984863094d5d5a388b1c928727.webp",
  },
  {
    id: 2,
    name: "Sterilization",
    category: "Sterilization",
    description: "High-quality Steam Sterilizers, available in various sizes to meet the customer's sterilization needs. With capacities ranging from 100 Liters up to 1000 Liters and single or double door options, &nbsp;sterilizers are designed to provide efficient and reliable sterilization for a wide range of applications",
    specs: ["Staineless Steal", "Shadowless Design", "Adjustable Color Temp", "Sterilizable Handles"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/497ede0ed985cab1b86fec3a4f6c9d4b.webp",
  },
  {
    id: 3,
    name: "Ventilators",
    category: "ICU",
    description: "High-performance ICU ventilators with advanced respiratory support modes, real-time monitoring, and intuitive touchscreen interfaces for critical patients.",
    specs: ["Multiple Ventilation Modes", "Touchscreen Interface", "O2 Blender Integrated", "Adult & Pediatric"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/e3e1b0a76e1b1d3daf0524d1b5923e99.jpeg",
  },
  {
    id: 4,
    name: "CPAP / BPAP Systems",
    category: "Respiratory",
    description: "Non-invasive CPAP and BiPAP systems for respiratory therapy in ICU, neonatal, and sleep medicine departments with automatic pressure adjustment.",
    specs: ["Auto-Adjusting Pressure", "Humidification Built-in", "Neonatal Compatible", "Quiet Operation"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/724d8932aab7d64ebbef446f103facbd.jpeg",
  },
  {
    id: 5,
    name: "Defibrillators",
    category: "Emergency",
    description: "Biphasic defibrillators with AED mode, ECG monitoring, and SpO2 measurement — essential life-saving devices for emergency and cardiac care departments.",
    specs: ["Biphasic Technology", "AED Mode", "ECG + SpO2", "Compact & Portable"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/d4bd4d4bddf384532f2c89e7f57dfe2b.png",
  },
  {
    id: 6,
    name: "Patient Monitors",
    category: "ICU",
    description: "Comprehensive multi-parameter patient monitoring systems displaying ECG, SpO2, NIBP, temperature, and capnography with central monitoring support.",
    specs: ["Multi-Parameter Display", "Central Station Ready", "Alarms Management", "Touchscreen 15\""],
    img: "https://public.readdy.ai/ai/img_res/749b9ea5c3315fbab98f587c5648ce36.jpg",
  },
  {
    id: 7,
    name: "X-Ray Systems",
    category: "Radiology",
    description: "Portable digital X-ray imaging units, Supplying Brand New and Refurbished CT Scanners, Angiography system, MRI systems, Replacing X-ray tubes from well-known manufacturers .",
    specs: ["High-Frequency Generator", "Digital Flat Panel", "Bedside Portable", "Wireless DR Panel"],
    img: "https://readdy.ai/api/search-image?query=mobile%20portable%20digital%20X-ray%20imaging%20machine%20in%20hospital%20ward%20setting%2C%20radiology%20equipment%20with%20robotic%20arm%2C%20clean%20white%20design%2C%20professional%20medical%20equipment%20photography%2C%20modern%20portable%20radiography%20unit%2C%20clinical%20environment&width=600&height=400&seq=eq007&orientation=landscape",
  },
  {
    id: 8,
    name: "Mobile C-Arm Systems",
    category: "Radiology",
    description: "Advanced mobile C-arm fluoroscopy systems for orthopedic, vascular, and general surgery — with flat detector technology and DICOM connectivity.",
    specs: ["Flat Detector Technology", "DICOM Connectivity", "High Pulsed Fluoroscopy", "Mobile & Compact"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/89bade0c0b9095ad9a25a96b23d538f9.jpeg",
  },
  {
    id: 9,
    name: "Lithotripsy Systems",
    category: "Urology",
    description: "Extracorporeal shock wave lithotripsy (ESWL) systems for non-invasive kidney stone treatment, with integrated X-ray and ultrasound targeting.",
    specs: ["ESWL Technology", "X-Ray + Ultrasound Targeting", "Non-Invasive Treatment", "High Stone Clearance Rate"],
    img: "https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/4e98233b83c0780ca26026b41d266a64.jpeg",
  },
];

const categories = ["All", "ICU", "Sterilization", "Radiology", "Emergency", "Respiratory", "Urology"];

export default function Equipment() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const filtered = activeCategory === "All"
    ? equipment
    : equipment.filter((e) => e.category === activeCategory);

  return (
    <section id="equipment" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-amber-400 mb-3">Our Product Range</span>
          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight">
            Premium Medical
            <span className="block text-amber-400">Equipment Catalog</span>
          </h2>
          <p className="mt-4 text-gray-400 text-base max-w-2xl mx-auto">
            Sourced from leading global manufacturers — every product meets international safety and quality standards.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap gap-2 justify-center mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`whitespace-nowrap px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide transition-all duration-200 cursor-pointer ${
                activeCategory === cat
                  ? "bg-amber-500 text-white"
                  : "bg-white/10 text-gray-300 hover:bg-white/20"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Equipment Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="rounded-xl overflow-hidden bg-gray-800 border border-gray-700 hover:border-amber-500/50 transition-all duration-300 cursor-pointer group"
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                <span className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold bg-amber-500/90 text-white">
                  {item.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-white mb-2">{item.name}</h3>
                <p className="text-sm text-gray-400 leading-relaxed mb-4">{item.description}</p>
                {hoveredId === item.id && (
                  <ul className="space-y-1.5 animate-pulse-once">
                    {item.specs.map((spec) => (
                      <li key={spec} className="flex items-center gap-2 text-xs text-gray-300">
                        <i className="ri-check-line text-amber-500 flex-shrink-0"></i>
                        {spec}
                      </li>
                    ))}
                  </ul>
                )}
                {hoveredId !== item.id && (
                  <div className="flex flex-wrap gap-1.5">
                    {item.specs.slice(0, 2).map((spec) => (
                      <span key={spec} className="px-2 py-0.5 rounded-full text-xs bg-gray-700 text-gray-300">
                        {spec}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
